export const VideoMetricColumns = [
  'VideoViews',
  'ViewThroughRate',
  'AverageCPV',
  'TotalWatchTimeInMS',
  'AverageWatchTimePerImpression',
  'AverageWatchTimePerVideoView',
  'VideoViewsAt25Percent',
  'VideoViewsAt50Percent',
  'VideoViewsAt75Percent',
  'CompletedVideoViews',
  'VideoCompletionRate',
];

export const performance = {
  AccountPerformanceReport: {
    default: [
      'AccountNumber',
      'AccountName',
      'AdDistribution',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'AverageCPM',
      'Spend',
      'AveragePosition',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
      'Conversions',
      'ConversionRate',
      'CostPerConversion',
    ],
    mandatory: [
      'AccountNumber',
      'AccountName',
      'Impressions',
    ],
    linechartDefault: [
      'AccountName',
    ],
    barchartDefault: [
      'AccountName',
    ],
  },
  CampaignPerformanceReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdDistribution',
      'QualityScore',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'AverageCPM',
      'Spend',
      'AveragePosition',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
      'Conversions',
      'ConversionRate',
      'CostPerConversion',
    ],
    mandatory: [
      'Impressions',
    ],
    linechartDefault: [
      'CampaignName',
    ],
    barchartDefault: [
      'CampaignName',
    ],
  },
  AdGroupPerformanceReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'AdGroupId',
      'AdDistribution',
      'QualityScore',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'AverageCPM',
      'Spend',
      'AveragePosition',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
      'Conversions',
      'ConversionRate',
      'CostPerConversion',
    ],
    mandatory: [
      'Impressions',
      'AdGroupId',
    ],
    linechartDefault: [
      'AdGroupName',
    ],
    barchartDefault: [
      'AdGroupName',
    ],
  },
  AdPerformanceReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'AdId',
      'AdType',
      'AdTitle',
      'TitlePart1',
      'TitlePart2',
      'TitlePart3',
      'AdDescription',
      'AdDescription2',
      'AdDistribution',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'AverageCPM',
      'Spend',
      'AveragePosition',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
      'Conversions',
      'ConversionRate',
      'CostPerConversion',
    ],
    mandatory: [
    ],
    linechartDefault: [
      'AdId',
    ],
    barchartDefault: [
      'AdId',
    ],
  },
  KeywordPerformanceReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'KeywordId',
      'Keyword',
      'BidMatchType',
      'AdDistribution',
      'CurrentMaxCpc',
      'QualityScore',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'Spend',
      'AveragePosition',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
      'Conversions',
      'ConversionRate',
      'CostPerConversion',
    ],
    mandatory: [
    ],
    linechartDefault: [
      'Keyword',
    ],
    barchartDefault: [
      'Keyword',
    ],
  },
  NegativeKeywordConflictReport: {
    mandatory: [
      'AccountName',
      'Keyword',
      'NegativeKeyword',
    ],
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupId',
      'Keyword',
      'NegativeKeyword',
      'ConflictLevel',
    ],
  },
  ShareOfVoiceReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'Language',
      'KeywordId',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'AverageCPM',
      'Spend',
      'AveragePosition',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
      'ImpressionSharePercent',
      'ImpressionLostToBudgetPercent',
      'ImpressionLostToRankAggPercent',
      'Conversions',
      'ConversionRate',
      'CostPerConversion',
    ],
    mandatory: [
      'KeywordId',
      'ImpressionSharePercent',
    ],
    linechartDefault: [
      'AdGroupName',
    ],
    barchartDefault: [
      'AdGroupName',
    ],
  },
  SearchQueryPerformanceReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'SearchQuery',
      'KeywordId',
      'Keyword',
      'AdId',
      'BidMatchType',
      'DeliveredMatchType',
      'Language',
      'Network',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'Spend',
      'AveragePosition',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
      'Conversions',
      'ConversionRate',
      'CostPerConversion',
    ],
    mandatory: [
      'SearchQuery',
    ],
    linechartDefault: [
      'SearchQuery',
    ],
    barchartDefault: [
      'SearchQuery',
    ],
  },
  DestinationURLPerformanceReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'DestinationUrl',
      'AdDistribution',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'Spend',
      'AveragePosition',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
      'Conversions',
      'ConversionRate',
      'CostPerConversion',
    ],
    mandatory: [
      'DestinationUrl',
    ],
    linechartDefault: [
      'DestinationUrl',
    ],
    barchartDefault: [
      'DestinationUrl',
    ],
  },
  PublisherUsagePerformanceReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'AssetGroupName',
      'PublisherUrl',
      'ViewThroughConversions',
      'ConversionsQualified',
      'ViewThroughCostPerConversionQualified',
      'CostPerConversionQualified',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'AverageCPM',
      'Spend',
      'AveragePosition',
      'Conversions',
      'ConversionRate',
      'CostPerConversion',
    ],
    mandatory: [
      'PublisherUrl',
    ],
  },
  AdDynamicTextPerformanceReport: {
    default: [
      'AccountName',
      'AdGroupName',
      'AdType',
      'AdTitle',
      'TitlePart1',
      'TitlePart2',
      'TitlePart3',
      'DestinationUrl',
      'Param1',
      'Param2',
      'Param3',
      'AdDistribution',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'Spend',
      'AveragePosition',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
      'Conversions',
      'ConversionRate',
      'CostPerConversion',
    ],
    mandatory: [
      'AdTitle',
      'DestinationUrl',
      'Param1',
      'Param2',
      'Param3',
    ],
  },
  AudiencePerformanceReport: {
    mandatory: [
      'AudienceId',
      'AccountId',
    ],
    default: [
      'AudienceId',
      'AudienceName',
      'AudienceType',
      'AccountNumber',
      'AccountName',
      'AccountId',
      'CampaignName',
      'AdGroupName',
      'AssociationStatus',
      'BidAdjustment',
      'TargetingSetting',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
      'Impressions',
      'Clicks',
      'CTR',
      'Spend',
    ],
  },
  GoalsAndFunnelsReport: {
    mandatory: [
      'Goal',
    ],
    default: [
      'Goal',
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'Assists',
      'AllConversions',
      'AllRevenue',
    ],
  },
  ConversionPerformanceReport: {
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'AdDistribution',
      'Impressions',
      'Clicks',
      'CTR',
      'Spend',
      'Assists',
      'Conversions',
      'ConversionRate',
      'Revenue',
      'ReturnOnAdSpend',
      'CostPerConversion',
    ],
    mandatory: [
    ],
  },
  UserLocationPerformanceReport: {
    mandatory: [
      'AccountName',
    ],
    default: [
      'AccountName',
      'CampaignName',
      'AdGroupName',
      'AdDistribution',
      'Country',
      'State',
      'MetroArea',
      'City',
      'County',
      'PostalCode',
      'LocationId',
      'QueryIntentCountry',
      'QueryIntentState',
      'QueryIntentDMA',
      'QueryIntentCity',
      'QueryIntentCounty',
      'QueryIntentPostalCode',
      'QueryIntentLocationId',
      'Impressions',
      'Clicks',
      'CTR',
      'AverageCPC',
      'AveragePosition',
      'TopImpressionRatePercent',
      'AbsoluteTopImpressionRatePercent',
      'Conversions',
      'ConversionRate',
      'CostPerConversion',
    ],
  },
  FeedItemPerformanceReport: {
    mandatory: [
      'FeedItemId',
    ],
    default: [
      'FeedItemId',
      'AccountId',
      'AccountName',
      'AccountNumber',
      'CampaignId',
      'CampaignName',
      'AdGroupId',
      'AdId',
      'FeedId',
      'Impressions',
      'Clicks',
      'Spend',
      'CTR',
      'AverageCPC',
      'Conversions',
      'Revenue',
      'ConversionRate',
      'ReturnOnAdSpend',
    ],
  },
  ConversionModelCompareReport: {
    mandatory: [
      'CampaignName',
    ],
    default: [
      'Goal',
      'LCAFullConversionCredit', // All conv. (LCA)
      'DDAFullConversionCredit', // All conv. (DDA)
      'ChangeInConversionCreditPct', // % Change in All conv.
      'LCAFullAdvertiserReportedRevenue', // All conv. revenue (LCA)
      'DDAFullAdvertiserReportedRevenue', // All conv. revenue (DDA)
      'ChangeInAdvertiserReportedRevenuePct', // % Change in All conv. revenue
      'LCAFullViewThroughConversion', // View-through conv. (LCA)
      'DDAFullViewThroughConversion', // View-through conv. (DDA)
      'ChangeInFullViewThroughConversionPct', // % Change in View-through conv.
      'LCAFullViewAdvertiserReportedRevenue', // View-through conv. revenue (LCA)
      'DDAFullViewAdvertiserReportedRevenue', // View-through conv. revenue (DDA)
      'ChangeInFullViewAdvertiserReportedRevenuePct', // % Change in View-through conv. revenue
    ],
  },
  MSXAccountPerformanceReport: {
    mandatory: [
      'CampaignName',
    ],
    default: [
      'GregorianDate',
      'msxPublisher',
      'msxDeliveredMarket',
      'msxDevice',
      'msxPageType',
      'msxPlacementId',
      'msxServedRevenue',
      'msxServedImpressions',
      'msxViewedImpressions',
      'msxAdClicks',
    ],
  },
  SearchInsightPerformanceReport: {
    default: [
      'SearchCategory',
      'Impressions',
      'Clicks',
      'Conversions',
      'Revenue',
      'CTR',
      'ConversionRate',
      'SearchVolume',
    ],
    mandatory: [
      'SearchCategory',
    ],
    linechartDefault: [
      'SearchCategory',
    ],
    barchartDefault: [
      'SearchCategory',
    ],
  },
  CombinationPerformanceReport: {
    mandatory: [],
    default: [
      'CustomerId',
      'CustomerName',
      'AccountName',
      'AccountNumber',
      'AccountId',
      'CampaignName',
      'CampaignId',
      'CampaignType',
      'AdGroupId',
      'AdGroupName',
      'AssetGroupId',
      'AssetGroupName',
      'AdId',
      'AdType',
      'Headline1',
      'Headline2',
      'Headline3',
      'CombinationLongHeadline',
      'Description1',
      'Description2',
      'Image',
      'Logo',
      'Impressions',
      'Clicks',
      'CTR',
      'Spend',
      'Conversions',
    ],
  },

};

